// extracted by mini-css-extract-plugin
export default {"dc_detail_box":"DetailsAndLights_dc_detail_box__CFSsT","dc_detail_title":"DetailsAndLights_dc_detail_title__twRQa"};